module.exports = __webpack_public_path__ + "img/wechat_official_qrcode_300x300.a884cb6.webp";